import '../vendor/sentry-lazy.js';
const environments = {
    'www.orental.ru': 'prod',
    'dev.orental.ru': 'test',
};
const filteredMessages = [
    'Timeout',
    'Method not found',
    'Syntax error in regular expression',
    'Event `ErrorEvent` captured as exception with message `Script error.`',
];
window.Sentry.onLoad(function () {
    window.Sentry.init({
        dsn: process.env.SENTRY_DSN,
        environment: environments[document.location.hostname] ?? 'dev',
        // integrations: [
        //   Sentry.replayIntegration(),
        // ],
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1,
        denyUrls: [
            'bitrix',
            /https?:\/\/(?!((www|dev).)?orental.(ru|devel|home.polosatus.ru))/,
            // Chrome extensions
            /extensions\//i,
            /^chrome(-extension)?:\/\//i,
        ],
        beforeSend(event, hint) {
            const originalException = hint.originalException;
            let message;
            // @ts-ignore
            if (window.document.documentMode) {
                // ignore IE
                return null;
            }
            if (typeof originalException === 'string') {
                message = originalException;
            }
            // @ts-ignore
            if (typeof originalException?.message === 'string') {
                // @ts-ignore
                message = originalException.message;
            }
            if (!message) {
                message = event?.exception?.values[0]?.value ?? 'Unknown';
            }
            if (filteredMessages.includes(message)) {
                return null;
            }
            if (event.exception && event.exception.values) {
                for (const exception of event.exception.values) {
                    if (exception.value.includes('window.yandex.sovetnik')) {
                        return null;
                    }
                    if (filterBitrixErrors(exception.stacktrace)) {
                        return null;
                    }
                }
            }
            if (isBurstProtectionActive()) {
                return null;
            }
            return event;
        }
    });
});
let lastEventTime;
let burstHits = 0;
let burstProtectionActive = false;
const MAX_BURST_EVENTS = 3;
function isBurstProtectionActive() {
    if (burstProtectionActive) {
        return true;
    }
    if (lastEventTime) {
        const now = new Date;
        if (now.getTime() - lastEventTime.getTime() < 3000) {
            burstHits++;
            if (burstHits >= MAX_BURST_EVENTS) {
                burstProtectionActive = true;
            }
        }
        else {
            lastEventTime = new Date();
            burstHits = 1;
        }
    }
    else {
        lastEventTime = new Date();
        burstHits = 1;
    }
    return false;
}
function filterBitrixErrors(stacktrace) {
    const re = new RegExp('bitrix|(/|^)crm/|chrome-extension');
    return !!stacktrace?.frames?.find(({ filename, module }) => {
        return filename && filename.match(re) || module && module.match(re);
    });
}
